import React from "react"; // add this
import posthog from "posthog-js";
import { Provider } from "react-redux";
import "react-image-crop/dist/ReactCrop.css";
import { createRoot } from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import { ThemeProvider } from "@mui/material/styles";
import { PersistGate } from "redux-persist/integration/react";

// import reportWebVitals from "./reportWebVitals";
import "./index.scss";
import App from "./app";
import { Env } from "./common/constants";
import theme from "./common/constants/theme";
import { store, persistor } from "./redux/store";

type ProvidersProps = {
  children: React.ReactNode;
};

const isPosthogEnabled = !!(
  Env.POSTHOG_KEY &&
  (Env.MODE === "pre-prod" || Env.MODE === "production")
);

if (isPosthogEnabled) {
  posthog.init(Env.POSTHOG_KEY, {
    api_host: Env.REVERSE_PROXY_TARGET || undefined,
    // Keep PostHog UI features (surveys, toolbar) working.
    ui_host: Env.POSTHOG_HOST || undefined,
    /** SPA route changes are sent from `PageViewTracker` */
    capture_pageview: false,
    /** We capture `button_clicked` with email + path; avoid duplicate generic `$autocapture` */
    autocapture: false,
  });
}

const Providers = ({ children }: ProvidersProps) => {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeProvider theme={theme}>{children}</ThemeProvider>
      </PersistGate>
    </Provider>
  );
};

const container = document.getElementById("root") as HTMLDivElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <Providers>
        <App />
      </Providers>
    </PostHogProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
//
